(function()
{
	var Application = include('springroll.Application');
	var CollisionUtils = include('collision.CollisionUtils');
	var Container = include('PIXI.Container');
	var Debug = include('springroll.Debug', false);
	var DebugOptions = include('nature.DebugOptions');
	var DelayedCall = include('springroll.DelayedCall');
	var Ease = include('createjs.Ease');
	var EventDispatcher = include('springroll.EventDispatcher');
	var Mode = include('nature.enum.Mode');
	var Powerup = include('nature.enum.Powerup');
	var RandomList = include('springroll.RandomList');
	var Sprite = include('PIXI.Sprite');
	var Texture = include('PIXI.Texture');
	var Tween = include('createjs.Tween');
	var TweenHelper = include('springroll.TweenHelper');

	var _configSeeds;
	var _rotateTime;
	var _extraXList;
	var _seedRidePositions;
	var _lockY;
	var _isInputDown;
	var _yVel;
	var _activePowerups;
	var _invulnerable;

	// A slight scale difference should break up visual monetenany 
	// if we have several shields active at once. 
	var _bubbleScaleList = new RandomList([0.8, 0.9, 1]);


	var SeedContainer = function(panel)
	{
		Container.call(this);

		/**
		 * Reference to the application
		 * @property {springroll.Application} app
		 */
		this.app = Application.instance;

		_configSeeds = this.app.config.seeds;
		_seedRidePositions = this.app.config.hal.seedRidePositions;

		this.update = this.update.bind(this);
		this.onInputDown = this.onInputDown.bind(this);
		this.onInputUp = this.onInputUp.bind(this);

		this.panel = panel;

		/**
		 * How much speed boost do the seeds have currently?
		 * @property {Number} boost
		 */
		this.boost = 0;

		_seeds = [];

		// Create seeds 
		var maxSeeds = DebugOptions.seeds || _configSeeds.maxSeeds;
		if (DebugOptions.powerup == Powerup.Life.name)
		{
			maxSeeds = 3;
		}
		for (var i = 0; i < maxSeeds; ++i)
		{
			var seed = new nature.Seed(i);
			this.addChild(seed);
			_seeds.push(seed);
		}

		this.x = _configSeeds.spawn.x;
		this.y = _configSeeds.spawn.y;
		this.alpha = _configSeeds.spawn.alpha;
		this.panel.camera.targetOffset = _configSeeds.spawn.x;

		// Horizontal speed
		this.xVel = 0;

		this.mode = Mode.Floating;

		_invulnerable = false;

		_activePowerups = [];
	};

	var s = Container.prototype;
	var p = extend(SeedContainer, Container);

	Object.defineProperty(p, 'isHealthFull',
	{
		get: function()
		{
			return _seeds.length === _configSeeds.maxSeeds;
		}
	});

	/**
	 * Set and hold the yVel (y axis velocity) at a determined, must
	 * return to 'null' to deactive
	 * @property {Number} lockY
	 */
	Object.defineProperty(p, 'lockY',
	{
		get: function()
		{
			return _lockY;
		},
		set: function(lock)
		{
			// Reset the yVel values 
			_yVel = 0;
			if (lock)
			{
				_isInputDown = false;
			}
			// Prevent 
			_lockY = lock;
			this.enabled = !lock;
		}
	});

	p._seeds = function()
	{
		return _seeds;
	};

	/**
	 * @param {} hoverTime
	 */
	p.start = function(hoverTime)
	{
		this.visible = true;
		var finalCameraPos = _configSeeds.travel.x + _configSeeds.cameraPaddingLeft;

		this.tweenSeedSpacing(DebugOptions.skipLaunch ?
			1 :
			_configSeeds.spawn.burstTweenTime);
		_isInputDown = false;
		_activePowerups.length = 0;

		if (DebugOptions.skipLaunch)
		{
			this.y = _configSeeds.spawn.burstEndY;
			this.xVel = this.getDefaultSpeed();
			this.alpha = 1;
			_yVel = 0;

			DelayedCall.calls.push(new DelayedCall(function()
			{
				this.emit('startControlCountdown', true);
				this.emit('startPlacingObjects');
			}.bind(this), 1500));
			this.panel.camera.targetOffset = finalCameraPos;
			return;
		}
		this.xVel = _configSeeds.spawn.burstSpeed;

		// Raise the seeds to the top of the screen...
		Tween.get(this)
			.to(
			{
				y: _configSeeds.spawn.burstY,
				alpha: 1
			}, _configSeeds.spawn.burstTweenTime, Ease.sineOut)
			.call(function()
			{
				this.lockY = true;
				_yVel = 0;

				if (!this.app.isTutorial)
				{
					DelayedCall.calls.push(new DelayedCall(function()
					{
						this.emit('startControlCountdown');
					}.bind(this), _configSeeds.spawn.burstTweenTime));
				}

				// Slowly bring the seeds back to the main gameplay postion
				Tween.get(this).to(
					{
						y: _configSeeds.spawn.burstEndY,
						xVel: this.getDefaultSpeed()
					}, _configSeeds.spawn.burstTweenTime + hoverTime, Ease.sineOut)
					.call(this.emit.bind(this, 'startPlacingObjects'));
			}.bind(this));

		Tween.get(this.panel.camera)
			.wait(_configSeeds.spawn.burstTweenTime)
			.to(
			{
				targetOffset: finalCameraPos
			}, hoverTime + _configSeeds.spawn.burstTweenTime, Ease.sineInOut);
	};

	/**
	 * @param {boolean} enabled
	 */
	Object.defineProperty(p, 'enabled',
	{
		get: function()
		{
			return this._enabled;
		},
		set: function(enable)
		{
			this._enabled = enable;

			var interaction = this.app.display.renderer.plugins.interaction;
			interaction.off('stagedown', this.onInputDown);
			interaction.off('stageup', this.onInputUp);

			var keyboard = this.app.keyboard;
			keyboard.removeKeyDown('spacebar', this.onInputDown);
			keyboard.removeKeyUp('spacebar', this.onInputUp);
			if (enable)
			{
				interaction.on('stagedown', this.onInputDown);
				interaction.on('stageup', this.onInputUp);
				keyboard.addKeyDown('spacebar', this.onInputDown);
				keyboard.addKeyUp('spacebar', this.onInputUp);
			}
		}
	});

	p.update = function(elapsed)
	{
		var delta = elapsed * 0.001;
		for (var i = _activePowerups.length - 1; i >= 0; --i)
		{
			_activePowerups[i].duration -= elapsed;
			if (_activePowerups[i].duration <= 0)
			{
				_activePowerups.splice(i, 1);
				this.invulnerable = false;
			}
		}

		// isApplyingBoost is active during the Tween that ramps up the boost
		if (this.boost > 0 && this.isApplyingBoost === false)
		{
			this.boost -= elapsed * 0.1;
			if (this.boost < 1)
			{
				this.boost = 0;
			}
		}

		// If hal's position is above the seeds, move them to Hal's space
		// ~szk: the seed ride position at hal's highest point471his jump has been moved to way off the top edge of the screen (in the Fla) rather than being directly positioned on his back--this prevents seeds at the top of the screen from not being collected
		if (this.mode == Mode.BeingCaught &&
			this.app.hal.ridePositionReference.y <= this.y)
		{
			this.moveToHal();
			this.mode = Mode.Riding;
		}

		if (this.mode == Mode.Riding)
		{
			// Loop through the seeds and apply the difference of the ridePositionReference
			// from its first frame position to the current frame's position, simulating
			// that the seeds are riding along Hal's back
			this.updateSeedsRidingPosition(elapsed);
			// The seedContainer now moves at Hal's speed, but we'll dampen it (* 0.95)
			// just a little so hal ends up moving forward along the screen during
			// the carry, and isn't totally locked in place
			this.x += (this.app.hal.speed * delta) * 0.95;
		}
		else
		{
			this.x += (this.xVel + this.boost) * delta;
		}

		if (this.mode == Mode.Floating && !DebugOptions.autoScroll)
		{
			this.updateYPos(elapsed);
			this.updateCollisions(elapsed);
		}
	};

	p.updateYPos = function(elapsed)
	{
		var i = null;
		var delta = elapsed * 0.001;
		var travel = _configSeeds.travel;

		if (_isInputDown)
		{
			_yVel -= travel.liftAccel * delta;
		}
		else
		{
			_yVel += travel.dropAccel * delta;
		}

		_yVel = Math.clamp(_yVel, -travel.liftSpeed, travel.dropSpeed);
		if (!_lockY)
		{
			this.y += _yVel * delta;
		}

		var maxY = this.app.isTutorial ? travel.maxY - 100 : travel.maxY;
		var minY = travel.minY;
		if (this.y > maxY)
		{
			if (this.app.isTutorial)
			{
				this.y = maxY;
				_yVel = 0; // -travel.liftSpeed;
				this.emit('heightWarning');
			}
			else
			{
				this.animateSeedsHittingGround();
				this.lose();
			}
		}
		else if (this.y < minY)
		{
			this.y = travel.minY;
			_yVel = 0;
		}
	};

	p.animateSeedsHittingGround = function()
	{
		_rotateTime = _rotateTime || new RandomList([1000, 1200, 1400]);
		for (var i = 0, len = _seeds.length; i < len; ++i)
		{
			var seed = _seeds[i];
			var extraX = 50;
			seed.floating = false;
			Tween.get(seed).to(
				{
					x: seed.x + extraX,
					y: seed.y + 200
				}, 400 + extraX, Ease.backIn)
				.call(this.removeSeed.bind(this, seed));
			// rotate
			Tween.get(seed.art.item).to(
			{
				rotation: seed.art.item.rotation - (Math.PI * 180)
			}, _rotateTime.random());
		}
	};

	p.updateCollisions = function(elapsed)
	{
		// Collision checking must be an i-- loop because of a splice deep within the checkCollision system
		for (var i = _seeds.length - 1; i >= 0; i--)
		{
			var seed = _seeds[i];
			// ~szk: Safety catch for a null seed after a splice goes wrong? Hopefully we can prevent this error as skipping over seeds is bad news... although, it happens every frame so maybe it's not a big deal
			if (seed && seed.collision)
			{
				seed.collision.updateOrigin(this.x + seed.x, this.y + seed.art.y);
				this.checkCollisions(seed, elapsed);
			}
		}
	};

	p.updateSeedsRidingPosition = function(elapsed)
	{
		// The seed positions are aligned to the first ride-position on the first frame of Hal's animation, but he moves up and down as he runs, so the first seed's position is tracked as absolutes, then applied relatively to all the other _seeds.
		var firstFrameY = this.app.hal.firstFrameY;
		var absY = this.app.hal.ridePositionReference.y;
		var diff = absY - firstFrameY;
		for (i = 0; i < _seeds.length; ++i)
		{
			seed = _seeds[i];
			seed.y = seed.ridePos.y + diff;
		}
	};

	p.checkCollisions = function(seed, elapsed)
	{
		var floaters = this.panel.floaters;
		var isFloating = this.mode == Mode.Floating;
		var seedCollision = seed.collision;
		var isTutorial = this.app.isTutorial;
		var floater = null;
		for (var i = 0, len = floaters.length; i < len; i++)
		{
			floater = floaters[i];
			if (!floater || !floater.enabled)
				continue;

			if (floater.isPowerup)
			{
				if (isFloating &&
					CollisionUtils.checkPolygonCollision(seedCollision, floater.collision))
				{
					floater.collide();
					// Apply speed boost/other powerup
					this.addPowerup(floater.powerupData, floater, seed);
					this.emit('collide', floater);
					break;
				}
			}
			else if (isFloating &&
				CollisionUtils.checkPolygonCollision(seedCollision, floater.collision))
			{
				floater.collide();
				if (isTutorial)
				{
					//we show what seed was affected to give user feedback, even though the seed can't actually die. 
					seed.spin(0, 1000);
				}
				else if (_invulnerable || DebugOptions.invincible)
				{
					// Only 'good' collisions, don't proceed any further, 
				}
				else if (seed.shield)
				{
					this.startInvulnerability();
					this.removeShield(seed);
				}
				else
				{
					this.loseSeed(floater, seed);
				}
				this.emit('collide', floater);
				break;
			}
		}

		floaters = null;
		isFloating = null;
		seedCollision = null;
		isTutorial = null;
		floater = null;
	};

	/**
	 * @param {nature.Floater} floater
	 * @param {nature.Seed} seed
	 */
	p.loseSeed = function(floater, seed)
	{
		// Find the index of the seed, must be an i-- loop because of THIS splice
		for (var i = _seeds.length - 1; i >= 0; i--)
		{
			if (seed.id == _seeds[i].id)
			{
				// Remove hit seed from the seed arr
				seed = _seeds.splice(i, 1)[0];
				break;
			}
		}

		seed.stop();

		this.app.sound.play('SeedGetsHit');

		if (_seeds.length)
		{
			Tween.get(seed.art.item).to(
			{
				x: -300,
				y: 650,
				rotation: seed.art.item.rotation + 360 * Math.randomInt(-1, 1),
			}, 1000, Ease.backIn).call(this.removeSeed.bind(this, seed));
			this.emit('loseSeed');
			this.startInvulnerability();
			this.tweenSeedSpacing();

			this.playSeedLoseVO();
		}
		else
		{
			this.stopCamera();
			var display = this.app.display;
			Tween.get(seed.art.item).to(
			{
				rotation: seed.art.item.rotation + 720
			}, 3000, Ease.sineOut);

			Tween.get(seed.art.item).to(
			{
				x: 100,
				y: seed.art.item.y - 50,
			}, 750, Ease.sineOut).call(this.lose.bind(this)).to(
			{
				x: display.width * 0.47,
				y: display.height,
			}, 1500 - this.y, Ease.quartIn);
		}
	};

	/**
	 * Seed collided with something lose a life
	 * @method handleLoseSeed
	 */
	p.playSeedLoseVO = function()
	{
		// Dispatched from seed container
		var vo = [
			'NCat_AnotherSeed',
			'NCat_UhOhSeed',
			'NCat_BeCareful',
			'NCat_Careful',
			'NCat_WatchOut',
			//play the 'NCat_Only1', 'NCat_Only2' or 'NCat_Only3'
			'NCat_Only' + _seeds.length
		].random();
		this.app.voPlayer.play(vo);
	};

	p.lose = function()
	{
		this.enabled = false;
		this.mode = Mode.Dead;
		this.stopCamera();
		this.emit('lose');
	};

	// Tween the camera to a stop
	p.stopCamera = function()
	{
		if (this.xVel > 0)
		{
			Tween.get(this).to(
			{
				xVel: 0
			}, this.xVel * 0.5, Ease.sineOut).call(function()
			{
				this.panel.camera.scrollingBackground.placeExtra();
			}.bind(this));
		}
	};

	/**
	 * @param {nature.Seed} seed 
	 */
	p.removeShield = function(seed)
	{
		this.app.sound.play('PopBubble1');
		seed.shield.enabled = false;
		this.app.animator.play(
			seed.shield.art.bubble,
			'bubble_pop',
			function()
			{
				seed.removeChildAt(seed.children.length - 1);
			});
		seed.shield = false;
	};

	/**
	 * @param 
	 */
	p.tweenSeedSpacing = function(equalTime)
	{
		// Take the absolute distance of the seed from it's end location, and make the tween time: that-number * TIME_MULTIPLIER
		var TIME_MULTIPLIER = 18;
		// The seeds don't move at once, they file in after each other
		var WAIT_OFFSET = 200;
		var seed;
		var newX;
		var time;
		var wait;
		var tween = equalTime ? Ease.sineOut : Ease.backInOut;
		var centerOffset = (_configSeeds.maxSeeds - _seeds.length) * (_configSeeds.spacing * 0.5);
		for (var i = 0, len = _seeds.length; i < len; ++i)
		{
			seed = _seeds[i];
			seed.floating = true;
			seed.id = i;
			// Space the seeds out from 0, but then apply an offset so the seeds seemingly center rather than space from right side  
			newX = -(_configSeeds.spacing * i) - centerOffset;

			time = equalTime || Math.abs(newX - seed.x) * TIME_MULTIPLIER;
			wait = equalTime ? 0 : (i * WAIT_OFFSET);
			Tween.get(seed).wait(wait).to(
			{
				x: newX
			}, time, tween);
		}
	};

	/**
	 * @param {nature.Seed} seed 
	 */
	p.removeSeed = function(seed)
	{
		Tween.removeTweens(seed.art.item);
		Tween.removeTweens(seed.art);
		Tween.removeTweens(seed);
		seed.parent.removeChild(seed);
		seed.destroy();
	};

	/**
	 * @param {nature.Floater} floater The Hal powerup floater
	 */
	p.onCollectHal = function(floater)
	{
		floater.move = function()
		{
			floater.alpha -= 0.2;
		};

		this.invulnerable = true;
		this.panel.seedContainer.lockY = true;
		// Copy positions, shuffle the copy, then grab only the number needed (else the shuffle will reorder the positions the same each time!). 
		var seedRidePositions = _seedRidePositions.slice().shuffle().slice(0, _seeds.length);
		// Sort the positions by X position, this way the leftmost seed will go to the leftmost x position chosen from the current set. Prevents an awkward cross over when the tween (more realistic)
		seedRidePositions.sort(function(a, b)
		{
			return a[0] > b[0];
		});
		// Assign a position to each seed
		for (var i = 0, len = _seeds.length; i < len; ++i)
		{
			// Choose a random ride position for the seed out of the predertimened spots (check the Fla file for pink-dots that indicate the current ride positions)
			var ridePos = seedRidePositions[i];
			// Save reference to the ridePos for position updating later
			_seeds[i].ridePos = {
				x: ridePos[0],
				y: ridePos[1]
			};
		}
	};

	/**
	 * Move seeds into hal's space
	 */
	p.moveToHal = function()
	{
		for (var i = 0, len = _seeds.length; i < len; ++i)
		{
			var seed = _seeds[i];
			// It's visually obnoxious to have the seeds blinking invulenerable while they are on hal, so we're turning it off for the ride duration of the powerup
			if (seed.invulnerableTween)
			{
				seed.invulnerableTween.pause();
			}
			// Stop the sine-wave floating of the seeds
			seed.floating = false;
			// Pop to Hal's container space
			this.app.hal.addChild(seed);
			seed.x = seed.ridePos.x;
			seed.y = seed.ridePos.y;
		}
	};

	p.moveOffHal = function()
	{
		this.emit('moveOffHal');

		// Move the seed container back to it's main position so the seeds can be
		this.y = _configSeeds.spawn.burstEndY;
		_yVel = 0;
		this.mode = Mode.Tweening;

		var sound = this.app.sound;
		sound.stop('HalRunningLoop');
		sound.play('HalLeaving');

		// Setting again the invulenerable to true tween turns on the flashing tween again, which was paused for the ride portion of the powerup because it's visually obnoxious
		this.invulnerable = true;

		// Tween the seeds separately to locations on Hal's body
		for (var i = 0, len = _seeds.length; i < len; ++i)
		{
			var seed = _seeds[i];

			// Pop back to regular container
			var pos = this.toLocal(
			{
				x: seed.x,
				y: seed.y
			}, this.app.hal);
			this.addChild(seed);
			seed.x = pos.x;
			seed.y = pos.y;

			// Spin 1, 2, or 3 times 
			Tween.get(seed).to(
			{
				rotation: Math.PI * [2, 4, 6].random(),
			}, 1000 * [2, 3].random(), Ease.backOut);

			// Tween the x spacing back to original
			Tween.get(seed).to(
			{
				x: -_configSeeds.spacing * (3 - i)
			}, 1000 * [1, 2, 3].random(), Ease.backOut);

			// Tween y above ending position, 
			Tween.get(seed).to(
				{
					y: 0 - Math.randomInt(25, 100),
				}, 1200 * [1, 1.25, 1.5].random(), Ease.sineOut)
				// dip down a bit below final position
				.to(
				{
					y: 0 + Math.randomInt(25, 50),
				}, 1000 * [1, 1.25, 1.5].random(), Ease.sineInOut)
				// settle into the actual position
				.to(
				{
					y: 0,
				}, 700, Ease.sineInOut)
				.call(moveToRiding.bind(this, seed));
		}

		var isLastCountdown = _seeds.length;

		function moveToRiding(seed)
		{
			seed.floating = true;
			if (--isLastCountdown <= 0)
			{
				// Mode of the entire container is Floating again
				this.mode = Mode.Floating;
			}
		}

		Tween.get(this).to(
		{
			xVel: this.getDefaultSpeed()
		}, 1000);
	};

	/**
	 * @param {nature.Floater} floater
	 * @param {nature.Seed} seed
	 */
	p.onCollectShield = function(floater, seed)
	{
		floater.visible = true;

		var availableSeed = false;
		if (!seed.shield)
		{
			seed.shield = floater;
			availableSeed = true;
		}
		else
		{
			for (var i = 0, len = _seeds.length; i < len; ++i)
			{
				seed = _seeds[i];
				if (!seed.shield)
				{
					seed.shield = floater;
					availableSeed = true;
					break;
				}
			}
		}

		if (availableSeed === false)
		{
			this.app.animator.play(floater.art.bubble, 'bubble_pop');
			return;
		}

		var pos = seed.toLocal(
		{
			x: floater.x,
			y: floater.y
		}, floater.parent);
		seed.addChild(floater);
		floater.x = pos.x;
		floater.y = pos.y;

		floater.enabled = false;
		var greaterDistXorY = Math.max(
			Math.abs(seed.x - floater.x),
			Math.abs(seed.y - floater.y));
		var scale = _bubbleScaleList.random();
		Tween.get(floater).to(
		{
			x: 0 - 5 * scale,
			y: 0
		}, greaterDistXorY * 5, Ease.backOut);
		Tween.get(floater.scale).to(
		{
			x: scale,
			y: scale
		}, greaterDistXorY * 8, Ease.backOut);
		Tween.get(floater.art.sparkleFX).to(
		{
			alpha: 0
		}, greaterDistXorY * 4).call(function()
		{
			floater.art.sparkleFX.visible = false;
		});
	};

	/**
	 * @param {nature.Floater} floater
	 */
	p.onCollectLife = function(floater)
	{
		// Double-check that we aren't full
		if (this.isHealthFull)
		{
			floater.enabled = false;
			floater.visible = false;
			return;
		}

		mixin(floater, nature.SeedActions);
		floater.visible = true;
		floater.enabled = false;

		var sparkleFX = floater.art.sparkleFX;
		Tween.get(sparkleFX).to(
		{
			alpha: 0
		}, 500).call(function()
		{
			sparkleFX.visible = false;
			floater.art.removeChild(sparkleFX);
		});

		var pos = this.toLocal(
		{
			x: floater.x,
			y: floater.y
		}, floater.parent);
		this.addChild(floater);
		floater.x = 0; //pos.x;
		floater.y = 0; //pos.y;

		_seeds.unshift(floater);
		Tween.get(floater).to(
		{
			y: 0
		}, 200).call(function()
		{
			// start tween the new seed
			floater.floating = true;
			this.tweenSeedSpacing();
		}.bind(this));
	};

	p.getDefaultSpeed = function()
	{
		var autoScroll = parseInt(DebugOptions.autoScroll);
		if (autoScroll)
		{
			return autoScroll;
		}
		else
		{
			return _configSeeds.travel.moveSpeed;
		}
	};

	Object.defineProperty(p, 'invulnerable',
	{
		get: function()
		{
			return _invulnerable;
		},
		set: function(value)
		{
			var i = null;
			// If we are setting invincible to false, check ALL the activePowerups to make sure there are no other invulnerable powerups with duration still running
			if (value === false)
			{
				for (i = _activePowerups.length - 1; i >= 0; --i)
				{
					var pu = _activePowerups[i];
					// if another active call is found, don't set Invulnerable to false just yet
					if (pu.type == Powerup.Invulnerable && pu.duration > 0)
						return;
				}
			}

			// Start or end the alpha tween on the seeds
			var invulnerableTween = _configSeeds.invulnerableTween;
			for (i = 0, len = _seeds.length, len = len; i < len; ++i)
			{
				var seed = _seeds[i];
				if (seed.invulnerableTween)
				{
					// Pausing unregisters the tween, allowing it to get garbage collected
					seed.invulnerableTween.pause();
					seed.invulnerableTween = null;
				}
				if (value)
				{
					seed.invulnerableTween = TweenHelper.build(seed.art, invulnerableTween);
					seed.invulnerableTween.loop = true;
				}
				else if (seed.alpha < 1)
				{
					Tween.get(seed).to(
					{
						alpha: 1
					}, 100);
				}
			}
			_invulnerable = value;
		}
	});

	/**
	 * Is seed container displaying the floating animation?
	 * @property {boolean} floating
	 */
	Object.defineProperty(p, 'floating',
	{
		set: function(floating)
		{
			for (var i = 0, len = _seeds.length; i < len; ++i)
			{
				_seeds[i].floating = floating;
			}
		}
	});

	/**
	 * @param {Number} [duration=_configSeeds.invulnerableTime]
	 */
	p.startInvulnerability = function(duration)
	{
		duration = duration || _configSeeds.invulnerableTime;
		this.addPowerup(
		{
			type: Powerup.Invulnerable,
			duration: duration,
			invulnerability: duration
		});
	};

	/**
	 * @param {Object} powerupData
	 * @param {nature.Floater} floater
	 * @param {nature.Seed} seed
	 */
	p.addPowerup = function(powerupData, floater, seed)
	{
		var powerup = {
			type: nature.enum.stringToEnum(powerupData.type, Powerup),
			timer: powerupData.duration,
			duration: powerupData.duration,
			invulnerability: powerupData.invulnerability
		};

		if (powerup.invulnerability)
		{
			_activePowerups.push(powerup);
			this.invulnerable = true;
		}

		switch (powerup.type)
		{
			case Powerup.Boost:
				this.app.sound.play('HitByWindGust');
				// Constrain the boost
				this.isApplyingBoost = true;
				var boostTarget = Math.min(this.boost + powerupData.speedBoost, _configSeeds.maxBoost);
				Tween.get(this).to(
				{
					boost: boostTarget
				}, boostTarget, Ease.cubicOut).call(function()
				{
					this.isApplyingBoost = false;
				});

				// Spin the seeds backwards to match the breeze anim, with a slight delay between them
				for (var i = 0, len = _seeds.length; i < len; i++)
				{
					var wait = 100 * i;
					var time = powerupData.invulnerability * [0.5, 0.6].random();
					_seeds[i].spin(wait, time);
				}
				break;
			case Powerup.Hal:
			case Powerup.Shield:
			case Powerup.Life:
				floater.collected = true;
				this.emit('collectPowerup',
				{
					type: powerup.type,
					floater: floater,
					seed: seed
				});
				break;
		}
	};

	p.removePowerup = function(powerup)
	{
		if (powerup.type == Powerup.Invulnerable)
		{
			this.invulnerable = false;
		}
	};

	p.stopSeeds = function()
	{
		for (var i = 0, len = _seeds.length; i < len; ++i)
		{
			_seeds[i].stop();
		}
	};

	p.onInputDown = function()
	{
		_isInputDown = true;
	};

	p.onInputUp = function()
	{
		_isInputDown = false;
	};

	p.destroy = function()
	{
		var interaction = this.app.display.renderer.plugins.interaction;
		interaction.off('stagedown', this.onInputDown);
		interaction.off('stageup', this.onInputUp);

		var keyboard = this.app.keyboard;
		keyboard.removeKeyDown('spacebar', this.onInputDown);
		keyboard.removeKeyUp('spacebar', this.onInputUp);

		this.invulnerable = false;
		this.stopSeeds();
		this.visible = false;
		this.enabled = false;
		this.floating = false;

		Tween.removeTweens(this);

		this.update = null;
		this.onInputDown = null;
		this.onInputUp = null;
		this.panel = null;

		_seeds = null;
		_activePowerups = null;

		s.destroy.call(this, true);
	};

	namespace('nature').SeedContainer = SeedContainer;

}());
